import '../scss/main.scss';
import './modules/scroll-reveal.js';
import './modules/ui-interactions.js';
import './modules/search-overlay.js';
import './modules/cart.js';
import './modules/address-cascade.js';
import './modules/checkout-submit.js';
import './modules/product-variants.js';
import './modules/product-gallery-viewer.js';
import './modules/account.js';
import './modules/contact.js';
import './modules/collection-filters.js';

document.documentElement.classList.add('js-page-ready');
